import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { withTranslation, useTranslation } from "react-i18next";
import { usePreCheckInContext } from "./contexts/PreCheckInContext";

const RegisterGuest = () => {
  const {
    propertyUid,
    bookingNumber,
    language,
    lastName,
    userEmail,
    data: { presets, guests },
    components: { PreCheckInHeader, PreCheckInContainer },
    func: { updateGuests },
  } = usePreCheckInContext();

  const history = useHistory();
  const { t } = useTranslation();
  useEffect(() => {}, []);

  const goToBookingDetail = () => {
    if (guests) {
      guests.allGuests().forEach((guest, index) => {
        guest.editable = guest.currentGuest;
        guests.UpdateByNumber(index, guest);
      });
      updateGuests(guests);
    }

    history.push(
      `/pre-checkin/${propertyUid}/book-detail/${encodeURIComponent(
        bookingNumber
      )}/${encodeURIComponent(
        lastName
      )}?language=${language}&email=${encodeURIComponent(userEmail)}`
    );
  };

  const addAdultPage = () => {
    history.push(
      `/pre-checkin/${propertyUid}/guest-list-management/${bookingNumber}/${encodeURIComponent(
        lastName
      )}/choose-guests-to-register?language=${language}&email=${encodeURIComponent(
        userEmail
      )}`
    );
  };

  return (
    <>
      <PreCheckInContainer containerName="register-guest">
        <PreCheckInHeader
          title={t("REGISTER_GUEST")}
          headerLink
        />
        {presets && (
          <section
            id="content"
            className="relative flex flex-col px-9 w-full flex-1 md:flex-0 pt-6">
            <div className="flex flex-col h-full">
              <div className="flex mb-10 w-full h-full">
                <div className="m-auto h-full">
                  <p
                    className="mb-12 type-normal large"
                    style={{ color: presets?.titleColor }}>
                    {t("ONLY_MYSELF_DESCRIPTION")}
                  </p>

                  <div className="flex flex-col justify-between md:justify-start h-full pb-72 md:pb-10">
                    <div className="mb-12 text-center">
                      <button
                        className={`app-outline-button type-title medium mb-4 capitalize ${presets?.buttonStyleName}`}
                        style={{
                          minWidth: "20rem",
                          backgroundColor: presets?.backgroundColorTopBar,
                          color: presets?.appHomeTextDetailsPrecheckin,
                        }}
                        onClick={() => goToBookingDetail()}>
                        {t("ONLY_MYSELF")}
                      </button>
                      <p
                        className="mb-12 type-regular medium capitalize"
                        style={{ color: presets?.subtitleColor }}>
                        {t("ONLY_MYSELF_DESCRIPTION")}
                      </p>
                    </div>

                    <div className="mb-12 text-center">
                      <button
                        className={`app-outline-button type-title medium mb-4 capitalize ${presets?.buttonStyleName}`}
                        style={{
                          minWidth: "20rem",
                          backgroundColor: presets?.backgroundColorTopBar,
                          color: presets?.appHomeTextDetailsPrecheckin,
                        }}
                        onClick={() => addAdultPage()}>
                        {t("MYSELF_AND_ADDITIONAL_GUEST")}
                      </button>
                      <p
                        className="mb-2 type-regular medium capitalize"
                        style={{ color: presets?.subtitleColor }}>
                        {t("MYSELF_AND_ADDITIONAL_GUEST_DESCRIPTION")}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}
      </PreCheckInContainer>
    </>
  );
};

export default withTranslation()(RegisterGuest);
